'use strict';

angular.module('nfseApp')
    .factory('AvisoSistema', function ($resource) {
        return $resource('api/publico/aviso-sistema/:id', {}, {
            'buscarAvisosVigentes': {
                url: 'api/publico/aviso-sistema/buscar-avisos-vigentes',
                method: 'GET',
                isArray: true
            }
        });
    });
